import type { PageHandle } from 'app/types';

const handle: PageHandle = {
  head: {
    title: 'An Error Occurred',
  },
};

export default handle;
